/* FF360 v1.9 - rail arrows + category tabs. No dependencies. */
(function () {
  function initRail(rail) {
    if (rail.__ffx) return;
    rail.__ffx = true;
    var track = rail.querySelector('.ffx-rail__track');
    var prev = rail.querySelector('[data-dir="-1"]');
    var next = rail.querySelector('[data-dir="1"]');
    if (!track) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        track.scrollBy({ left: track.clientWidth * 0.85 * Number(btn.dataset.dir), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    rail.__ffxUpdate = update;
    update();
  }

  function initTabs(root) {
    if (root.__ffx) return;
    root.__ffx = true;
    var tabs = root.querySelectorAll('.ffx-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('is-on'); t.setAttribute('aria-selected', 'false'); });
        root.querySelectorAll('.ffx-panel').forEach(function (p) { p.classList.remove('is-on'); });
        tab.classList.add('is-on');
        tab.setAttribute('aria-selected', 'true');
        var panel = root.querySelector('[data-panel="' + tab.dataset.tab + '"]');
        if (panel) {
          panel.classList.add('is-on');
          panel.querySelectorAll('[data-ffx-rail]').forEach(function (r) { initRail(r); if (r.__ffxUpdate) r.__ffxUpdate(); });
        }
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-ffx-rail]').forEach(initRail);
    (scope || document).querySelectorAll('[data-ffx-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Theme editor: re-init when a section is added or changed
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* v1.9b - sold-out products last on collection/search pages, and reveal-on-scroll for homepage rows */
(function () {
  function soldOutLast(scope) {
    (scope || document).querySelectorAll('product-list').forEach(function (list) {
      var cards = Array.prototype.slice.call(list.children);
      var isOut = function (c) { return !!(c.querySelector && c.querySelector('.badge--sold-out')); };
      var firstOut = cards.findIndex(isOut);
      if (firstOut === -1) return;
      var needs = cards.slice(firstOut).some(function (c) { return !isOut(c); });
      if (!needs) return; // already ordered: avoid re-triggering observers
      cards.filter(isOut).forEach(function (c) { list.appendChild(c); });
    });
  }
  function reveal() {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var els = document.querySelectorAll('.ffx-sec, .ff-sec');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < window.innerHeight) return; // already on screen: leave as is
      el.classList.add('ffx-reveal'); io.observe(el);
    });
  }
  function init() { soldOutLast(); reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  // Filters/sort re-render the product list: re-apply ordering
  var mo = document.querySelector('.shopify-section--main-collection, .shopify-section--main-search');
  if (mo) new MutationObserver(function () { soldOutLast(mo); }).observe(mo, { childList: true, subtree: true });
  document.addEventListener('facet:update', function () { setTimeout(soldOutLast, 50); });
})();
